import { ChangeEvent, KeyboardEvent } from 'react';

export enum SearchInputVariantEnum {
  onlyIcon = 'only-icon',
  withLabel = 'with-label',
}

export interface SearchInputProps {
  value?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  searchHint?: string;
  searchTip?: string;
  onKeyPress: (event: KeyboardEvent<HTMLInputElement>) => void;
  theme?: Theme;
  variant?: SearchInputVariantEnum.onlyIcon | SearchInputVariantEnum.withLabel;
  searchLabel: string;
  onSearchButtonClick?: () => void;
}
